import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {Roles} from '../model/enums';

/*
  The Mobile module is available for everyone except VIP users.
 */
@Injectable({
  providedIn: 'root'
})
export class MobileGuard implements CanActivate {

  public constructor(private auth: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.auth.hasAnyRole([Roles.VIP]).then(hasAnyRole => {
      if (hasAnyRole) {
        return this.router.parseUrl('/vip');
      } else {
        return true;
      }
    }, () => false);
  }

}
